import {createContext} from "react";

export const CustomButtonContext = createContext({
    disabled: false,
    buttonVariant: 'contained',
    color: 'default'
})
